
export class GetDeliveryLocationPayload {
    constructor() {

    }

    CustomerId: any;
    UserName: any;
    AgentId: any;
    TenantId: any;
    StaggingId: any;
    DeliveryLocationId: any;
}



